
import { createComponent, reactive, computed } from "@vue/composition-api";

type Props = {
  textDataList: {}[];
};

export default createComponent({
  props: {
    textDataList: {
      type: Array,
      default: [],
    },
  },
  setup(props: Props) {
    const state = reactive({
      textDataList: computed(() => props.textDataList),
    });

    return {
      state,
    };
  },
});
